import React from "react";

const ExhibitorInfoBar = ({ exhibitorData }) => {
  // Default data (can be overridden by props from API)
  const data = exhibitorData || {
    exhibitorNumber: "E60",
    exhibitorName: "The Espoma Company",
    merchant: "Steve Marut"
  };

  return (
    <div className="exhibitor-info-bar">
      <div className="exhibitor-info-item">
        <span className="exhibitor-info-label">Exhibitor #:</span>
        <span className="exhibitor-info-value">{data.exhibitorNumber}</span>
      </div>
      <div className="exhibitor-info-item">
        <span className="exhibitor-info-label">Exhibitor Name:</span>
        <span className="exhibitor-info-value">{data.exhibitorName}</span>
      </div>
      <div className="exhibitor-info-item">
        <span className="exhibitor-info-label">Merchant:</span>
        <span className="exhibitor-info-value">{data.merchant}</span>
      </div>
    </div>
  );
};

export default ExhibitorInfoBar;
